import { BaseFiltroPaginate } from "resources/enums/paginate";
import { useCallback, useState } from "react";
import { FiltroEquipamentos } from "core/features/equipamento/typings/index";

function useFiltroEquipamentos() {
  const [filtro, setFiltro] = useState<FiltroEquipamentos>({
    page: 1,
    limit: BaseFiltroPaginate.Limit,
    search: "",
    local: undefined,
    areaComumId: undefined,
  });

  const onChangeFiltro = useCallback((_filtro: Partial<FiltroEquipamentos>) => {
    setFiltro((state) => ({ ...state, ..._filtro }));
  }, []);

  const onResetFiltro = useCallback(() => {
    setFiltro((state) => ({
      ...state,
      local: undefined,
      areaComumId: undefined,
      page: 1,
    }));
  }, []);

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
    onResetFiltro,
  };
}

export default useFiltroEquipamentos;
